<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Item Sales Register Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :disabledDates="{
                    from: new Date(
                      moment(fromDate).add(31, 'd').format('YYYY-MM-DD')
                    ),
                  }"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getSalesRegisterReport()"
            >
              {{ $t("fetch") }}
             
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-2 align-self-center mb-3 d-flex justify-content-end align-items-center p-0"
            v-if="salesRegisterRecords.length"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <span
              @click="excelDownload(REPORT_URL)"
              title="Download as Excel"
              style="cursor: pointer"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div
            class="d-flex align-item-center justify-content-center"
            style="gap: 15px"
          >
            <b-form-input
              v-debounce:500="onSearch"
              v-model="searchValue"
              placeholder="Search..."
            />
          </div>
          <div class="d-flex"></div>
          <div class="align-items-center">
            <div class="mx-2 text-left d-flex justify-content-end">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  {{ $t("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;{{ $t("of") }}&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div
        style="overflow-x: scroll !important; width: auto !important"
        v-if="salesRegisterRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <th>Unit Name</th>
            <th>Business Date</th>
            <th>Transaction Id</th>
            <th>Receipt No</th>
            <!-- <th>Digital OrderId</th> -->
            <th>DB Date & Time</th>
            <th>Invoice No.</th>
            <th>OutLet</th>
            <th>Food Category</th>
            <th>Movie/Item</th>
            <th>ShowDate</th>
            <th>Calender Date</th>
            <th>ShowTime</th>
            <th>POS ID</th>
            <th>Employe Code</th>
            <th>User Name</th>
            <th>Screen Name</th>
            <th>Partner ID</th>
            <th>Sell Type</th>
            <th>Terminal ID</th>
            <th>Merchant Track ID</th>
            <th>Refernce ID</th>
            <!-- <th>STAN</th>
            <th>TVR</th> -->
            <th>Card No.</th>
            <th>Approval Code</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Amount Exclude VAT</th>
            <!-- <template v-for="(chargesData, chargesIndex) in chargesArr"> -->
            <th>VAT</th>
            <!-- </template> -->
            <th>Total Amount</th>
            <th>Payment Method</th>

            <th>Total Invoice Amount</th>
            <th>Voucher/Offer Name</th>
            <th>Voucher/Offer Code</th>
            <th>Discount</th>

            <th>Refund Type</th>
            <th>Refunded By</th>
            <th>Refund Reason</th>
            <template v-if="addonsTotalArr.length">
              <template v-for="item in addonsTotalArr">
                <th v-for="(item1, index) in 3" :key="index + item.marc_id">
                  {{
                    index == 0
                      ? `${item.addons_name} Charge`
                      : index == 1
                      ? ` VAT on ${item.addons_name} Charge`
                      : ` Total ${item.addons_name} Charge`
                  }}
                </th>
              </template>
            </template>
            <th>Print</th>
          </tr>
          <tbody>
            <template
              v-for="(
                salesRegisterData, salesRegisterIndex
              ) in salesRegisterRecords"
            >
              <tr
                v-if="salesRegisterData.hasOwnProperty('fst_id')"
                :key="salesRegisterIndex + 'fnbDataIndex'"
              >
                <td class="text-left">{{ salesRegisterData.unit_name }}</td>
                <td class="text-left">
                  {{ salesRegisterData.payment_date || "-" }}
                </td>
                <td class="text-left" :style="comboColor(salesRegisterData)">
                  {{ String(salesRegisterData.invoice_no) || "-" }}
                </td>
                <td class="text-right">
                  {{ salesRegisterData.order_code }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.created_at || "-" }}
                </td>
                <td
                  class="text-left"
                  :class="salesRegisterData.refund_mode ? 'text-danger' : ''"
                >
                  {{ salesRegisterData.invoice_code }}
                </td>
                <td class="text-left">{{ salesRegisterData.outlet || "-" }}</td>
                <td class="text-left" :style="comboColor(salesRegisterData)">
                  {{ salesRegisterData.fc_category }}
                </td>
                <td class="text-left" :style="comboColor(salesRegisterData)">
                  {{ salesRegisterData.fst_item_name }}
                </td>

                <td class="text-left">
                  {{ salesRegisterData.show_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.business_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.show_time || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.hardware_info
                      ? salesRegisterData.hardware_info
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.up_employee_code
                      ? salesRegisterData.up_employee_code
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.first_name }}
                  {{ salesRegisterData.last_name }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.screen_name || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.partner_name || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.Combo_item_name
                      ? `Combo - ${salesRegisterData.Combo_item_name}`
                      : salesRegisterData.combo_data
                      ? "Combo"
                      : "Single"
                  }}
                </td>
                <td class="text-left">
                  <div
                    v-if="
                      salesRegisterData.payment_transaction_detail &&
                      !salesRegisterData.card_trx_details
                    "
                  >
                    {{
                      salesRegisterData.payment_transaction_detail
                        .TRANSPORTAL_ID || "-"
                    }}
                  </div>
                  <div v-else-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail
                        .CardAcceptorTerminalId || "-"
                    }}
                  </div>
                  <div v-else>-</div>

                  <!-- {{
                    getSafe(
                      () =>
                        salesRegisterData.payment_transaction_detail
                          .transaction[
                          salesRegisterData.payment_transaction_detail
                            .transaction.length - 1
                        ].transaction.terminal
                    ) ||
                      getSafe(
                        () =>
                          salesRegisterData.payment_transaction_detail
                            .CardAcceptorTerminalId
                      ) ||
                      "-"
                  }} -->
                </td>

                <td class="text-right">
                  <div
                    v-if="
                      salesRegisterData.payment_transaction_detail &&
                      !salesRegisterData.card_trx_details
                    "
                  >
                    {{
                      salesRegisterData.payment_transaction_detail.trackid ||
                      "-"
                    }}
                  </div>
                  <div v-else-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail.TrackId ||
                      "-"
                    }}
                  </div>
                  <div v-else>-</div>
                  <!-- {{
                    getSafe(
                      () => salesRegisterData.payment_transaction_detail.fort_id
                    ) ||
                      getSafe(
                        () =>
                          salesRegisterData.payment_transaction_detail
                            .transaction[
                            salesRegisterData.payment_transaction_detail
                              .transaction.length - 1
                          ].transaction.receipt
                      ) ||
                      getSafe(
                        () =>
                          salesRegisterData.payment_transaction_detail
                            .RetrievalReferenceNumber
                      ) ||
                      "-"
                  }} -->
                </td>
                <td class="text-right">
                  <div
                    v-if="
                      salesRegisterData.payment_transaction_detail &&
                      !salesRegisterData.card_trx_details
                    "
                  >
                    {{
                      salesRegisterData.payment_transaction_detail.ref || "-"
                    }}
                  </div>
                  <div v-else-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail
                        .RetrievalReferenceNumber || "-"
                    }}
                  </div>
                  <div v-else>-</div>
                </td>

                <!-- <td class="text-right">
                  <div v-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail
                        .TransactionSTAN || "-"
                    }}
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="text-right">
                  <div v-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail.TVR || "-"
                    }}
                  </div>
                  <div v-else>-</div>
                </td> -->
                <td class="text-right">
                  <div
                    v-if="
                      salesRegisterData.payment_transaction_detail &&
                      !salesRegisterData.card_trx_details
                    "
                  >
                    {{
                      salesRegisterData.payment_transaction_detail.card || "-"
                    }}
                  </div>
                  <div v-else-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail
                        .PrimaryAccountNumber || "-"
                    }}
                  </div>
                  <div v-else>-</div>
                  <!-- {{
                    getSafe(
                      () =>
                        salesRegisterData.payment_transaction_detail.card_number
                    ) ||
                      getSafe(
                        () =>
                          salesRegisterData.payment_transaction_detail
                            .sourceOfFunds.provided.card.number
                      ) ||
                      getSafe(
                        () =>
                          salesRegisterData.payment_transaction_detail
                            .PrimaryAccountNumber
                      ) ||
                      "-"
                  }} -->
                </td>
                <td class="text-left">
                  <div
                    v-if="
                      salesRegisterData.payment_transaction_detail &&
                      !salesRegisterData.card_trx_details
                    "
                  >
                    {{
                      salesRegisterData.payment_transaction_detail
                        .authRespCode || "-"
                    }}
                  </div>
                  <div v-else-if="salesRegisterData.card_trx_details">
                    {{
                      salesRegisterData.payment_transaction_detail.AID || "-"
                    }}
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fst_quantity > 0
                      ? "-"
                      : ""
                  }}{{ salesRegisterData.fst_quantity }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(
                      salesRegisterData.fp_total_amount /
                        salesRegisterData.fst_quantity
                    ) || "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_amount > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_amount) || "0.0" }}
                </td>

                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0 &&
                    !salesRegisterData.Combo_item_name
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(
                      salesRegisterData.fp_total_amount -
                        salesRegisterData.fp_amount
                    ) || "0.0"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.fp_total_amount) || "0.0"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.fst_payment_mode }}
                </td>

                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.fp_total_amount) || "0.0"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.ft_voucher_name ||
                    salesRegisterData.ft_offer_name ||
                    "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.ft_voucher_code ||
                    salesRegisterData.ft_offer_code ||
                    "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_offer_price > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_offer_price) || "-" }}
                </td>

                <td class="text-left">
                  {{ salesRegisterData.refund_mode || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_mode
                      ? salesRegisterData.refund_first_name +
                        salesRegisterData.refund_last_name
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.refund_reason || "-" }}
                </td>
                <template v-if="addonsTotalArr.length">
                  <template v-for="item2 in addonsTotalArr">
                    <td
                      class="text-right"
                      v-for="(item1, index2) in 3"
                      :key="index2 + item2.marc_id"
                    >
                      <template>-</template>
                    </td>
                  </template>
                </template>
                <td>
                  <button
                    class="btn-transparent text-blue"
                    @click="printPdf(salesRegisterData)"
                  >
                    <u>View Invoice</u>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div ref="onPrint" class="d-none">
        <div v-html="EjsData"></div>
      </div>
      <div class="swc-report" v-if="salesRegisterRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Unit Name</th>
            <th>Business Date</th>
            <th>Transaction Id</th>
            <th>Receipt No</th>
            <!-- <th>Digital OrderId</th> -->
            <th>DB Date & Time</th>
            <th>Invoice No.</th>
            <th>OutLet</th>
            <th>Food Category</th>
            <th>Movie/Item</th>
            <th>ShowDate</th>
            <th>Calender Date</th>
            <th>ShowTime</th>
            <th>POS ID</th>
            <th>Employe Code</th>
            <th>User Name</th>
            <th>Screen Name</th>
            <th>Partner ID</th>
            <th>Sell Type</th>
            <th>Terminal ID</th>
            <th>Merchant Track ID</th>
            <th>Refernce ID</th>
            <!-- <th>STAN</th>
            <th>TVR</th> -->
            <th>Card No.</th>
            <th>Approval Code</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Amount Exclude VAT</th>
            <!-- <template v-for="(chargesData, chargesIndex) in chargesArr"> -->
            <th>VAT</th>
            <!-- </template> -->
            <th>Total Amount</th>
            <th>Payment Method</th>

            <th>Total Invoice Amount</th>
            <th>Voucher/Offer Name</th>
            <th>Voucher/Offer Code</th>
            <th>Discount</th>

            <th>Refund Type</th>
            <th>Refunded By</th>
            <th>Refund Reason</th>
            <template v-if="addonsTotalArr.length">
              <template v-for="item in addonsTotalArr">
                <th v-for="(item1, index) in 3" :key="index + item.marc_id">
                  {{
                    index == 0
                      ? `${item.addons_name} Charge`
                      : index == 1
                      ? ` VAT on ${item.addons_name} Charge`
                      : ` Total ${item.addons_name} Charge`
                  }}
                </th>
              </template>
            </template>
            <th>Print</th>
          </thead>

          <tbody>
            <tr>
              <td colspan="40">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-if="salesRegisterRecords.length > 0"
      v-model="currentPage"
      :total-rows="paginateRows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import NewReportService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { createQueryString } from "@/services/ApiHelper";
import PosFnbService from "@/services/PosFnbService";

import PosService from "@/services/PosService";
import Printd from "printd";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      disabledDates: {
        from: new Date(),
      },
      paginateRows: 0,
      perPage: 50,
      currentPage: 1,
      rows: 0,
      guestRows: 0,
      selectedvalue: "50",
      viewingnumbers: [
        { name: "50", id: 1 },
        { name: "100", id: 2 },
        { name: "200", id: 3 },
        { name: "300", id: 4 },
      ],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      searchValue: "",

      BASEURL,
      isRoleID: false,
      submitted: false,
      search: "",
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      salesRegisterRecords: [],
      fnbSalesRecords: [],
      chargesArr: [],
      addonsTotalArr: [],
      tempData: [],
      EjsData: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // }
  },
  mounted() {},
  methods: {
    async printPdf(salesRegisterData) {
      console.log(salesRegisterData, "salesRegisterData");
      // return false;
      let isReprint = true;
      let response;

      let loader = this.$loading.show();

      if (salesRegisterData.hasOwnProperty("fst_id")) {
        if (
          salesRegisterData.refund_mode &&
          salesRegisterData.refund_mode != "-"
        ) {
          response = await PosFnbService.GetFnbRefundEjs({
            OrderCode: salesRegisterData.order_code,
            Type: "Print",
            UserID: salesRegisterData.user_created_id,
            isReprint,
            isRefund: true,
          }).catch(this._CatchError);
        } else {
          response = await PosFnbService.GetFnbOrderEjs({
            OrderCode: salesRegisterData.order_code,
            Type: "Print",
            UserID: salesRegisterData.user_created_id,
            isReprint,
          }).catch(this._CatchError);
        }
      }

      if (response) {
        const { data } = response;
        this.EjsData = data;
        this.$nextTick(() => {
          loader.hide();
          const p = new Printd();
          if (this.$refs.onPrint && this.EjsData != null) {
            p.print(this.$refs.onPrint, []);
          }
        });
      }
    },
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    onSearch() {
      this.currentPage = 1;
      this.getSalesRegisterReport();
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getSalesRegisterReport();
      } else {
        this.currentPage = event;
        this.getSalesRegisterReport();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.resetList();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.resetList();
      }
    },
    resetList() {
      // let loader = this.$loading.show();
      this.isSort = false;
      this.isAscending = true;
      this.isAscending = true;
      this.orderby = "";
      this.columnName = "";
      this.currentPage = 1;
      this.getSalesRegisterReport();
    },
    comboColor(data) {
      if (data.Combo_item_name) {
        return `color:green;font-weight:bold`;
      }

      return "";
    },
    onSearchFile: function (value) {
      if (this.search && this.search.length > 0) {
        let search_value = String(this.search || "").toLowerCase();
        let check_array = [
          "movie",
          "payment_method",
          "screen_name",
          "unit_name",
          "invoice_no",
          "outlet",
          "fst_item_name",
          "fc_category",
          "fst_item_name",
          "fst_payment_mode",
          "order_code",
        ];
        this.salesRegisterRecords = this.tempData.filter((x) => {
          let obj = {};
          let check = false;
          check_array.map((y) => {
            if (typeof x[y] == "object" || !x[y]) {
              // console.log(x[y],"x[y]");
              // obj[y] = JSON.stringify(x[y])
              //   .toLowerCase()
              //   .includes(search_value);
              obj[y] = false;
            } else {
              obj[y] = String(x[y] || "")
                .toLowerCase()
                .includes(search_value);
            }

            if (!check && obj[y]) {
              check = true;
            }
          });
          return check;
        });
      } else {
        this.salesRegisterRecords = this.tempData;
      }
    },
    getDataAddons(data, index, m_id) {
      let filterData = data.findIndex((z) => {
        return z.marc_id == m_id;
      });
      let totalValue = "-";
      if (filterData >= 0) {
        if (index == 0) {
          totalValue = data[filterData].singlenetCharge;
        } else if (index == 1) {
          totalValue = data[filterData].totalTaxCharge;
        } else {
          totalValue = data[filterData].final_price;
        }
      }

      return totalValue;
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: "ItemSalesRegisterReport",
      });
      let loader = this.$loading.show();

      Object.keys(wb.Sheets.ItemSalesRegisterReport)
        .filter((_t) => _t.charAt(0) == "C")
        .map((z) => {
          wb.Sheets.ItemSalesRegisterReport[z].t = "s";
        });
      console.log(wb);
      loader.hide();
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn || "ItemSalesRegisterReport." + (type || "xlsx")
          );
    },
    moment,
    excelDownload(BASE_URL) {
      try {
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        if (!this.toDate) {
          return this.$toasted.show("Select To Date");
        }
        if (moment(this.toDate).isBefore(this.fromDate)) {
          return this.$toasted.show(
            " To Date Should be Greater than From Date"
          );
        }
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel: "Y",
          onlyFnb: true,
        };
        let qs = createQueryString(payload);
        window.open(`${BASE_URL}/api/reports/itemSalesRegisterReport${qs}`);
      } catch (err) {
        console.log("Error:", err);
      }
    },
    _excelDownload() {
      let temp_data = [];
      this.houseKeepingRecords.map((x, index) => {
        let obj = { ...x, index: index + 1 };
        temp_data.push(obj);
      });
      let data = [
        {
          sheet: "House Keeping Report",
          columns: [
            {
              value: (row) => moment(row.schedule_date).format("YYYY-MM-DD"),
              label: "Date",
            },
            {
              value: "cinema_name",
              label: "Branch",
            },
            {
              value: "index",
              label: "Show No.",
            },
            {
              value: "screen_name",
              label: "Screen Name",
            },
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "start_time",
              label: "Start Time",
            },
            {
              value: "end_time",
              label: "End Time",
            },
            {
              value: (row) =>
                row.screen_total_seats ? row.screen_total_seats : "-",
              label: "Capacity",
            },
            {
              value: (row) =>
                row.booked_seats && row.screen_total_seats
                  ? +parseFloat(
                      parseFloat(row.booked_seats / row.screen_total_seats) *
                        100
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Occupancy",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `HouseKeepingReport_${
          this.dropDown.selectedCinemaName
        }_${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // let cinemas = [
            //   {
            //     cine_id: "all",
            //     cine_name: "All Cinemas",
            //   },
            // ];
            this.dropDown.cinemas = [ ...data.Records];
            this.CinemasCopy = [ ...data.Records];
            // this.dropDown.cinemas = [...data.Records];
            // this.CinemasCopy = [...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getSalesRegisterReport() {
      this.salesRegisterRecords = [];
      this.fnbSalesRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      }

      if (moment(this.toDate).isBefore(this.fromDate)) {
        return this.$toasted.show(" To Date Should be Greater than From Date");
      }

      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        onlyFnb: true,
      };
      NewReportService.ItemSalesRegister(payload)
        .then((response) => {
          const { data } = response;
          if (
            data &&
            data.hasOwnProperty("totalCount") &&
            this.currentPage == 1 &&
            data &&
            data.hasOwnProperty("largeCount")
          ) {
            this.rows = data.totalCount;
            this.paginateRows = data.largeCount;
            if (data.totalCount >= 10) {
              this.rows = data.totalCount;
            } else {
              this.rows = data.totalCount;
              this.selectedvalue = data.totalCount;
            }
          }
          if (data.status && data.Records.length > 0) {
            this.salesRegisterRecords = [...data.Records];
            this.tempData = [...data.Records];
            // this.fnbSalesRecords = [...data.fnbSalesRecords];
            this.chargesArr = [...data.chargesRecords];
            this.addonsTotalArr = [...data.addons_array];
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/itemSalesRegisterReportSingleNew.vue